// applications/_shared/types/information-request — shared by `espace` (which needs to know
// WHETHER a submitted dossier has anything outstanding, to show "Action requise" instead of the
// plain received card) and `respond` (which needs the full row to render each one).
import { z } from "zod";

/**
 * `GET /applications/{id}/information-requests/` — the candidate's own view of one request.
 * Deliberately narrower than the coordinator-side `DossierInformationRequestSchema`
 * (`operations/types/dossier.ts`): no `subject_label_i18n` map, just one already-localized
 * `subject_label` string — this endpoint answers "what does MY dossier need", not "render this
 * in every locale the round supports".
 */
export const InformationRequestSchema = z.object({
  id: z.string(),
  requested_type: z.enum(["DOCUMENT", "QUESTION", "FIELD"]),
  subject_ref: z.string(),
  subject_label: z.string(),
  note: z.string().nullable(),
  due_at: z.string(),
  state: z.enum(["OPEN", "SATISFIED", "CANCELLED"]),
});

export type InformationRequest = z.infer<typeof InformationRequestSchema>;
